import { html as beautifyHtml } from "js-beautify";

export function formatHtml(data) {
  try {
    return beautifyHtml(data, {
      indent_size: 2,
      wrap_line_length: 80,
    });
  } catch (error) {
    console.error("HTML formatting error:", error);
    return data;
  }
}
